// ExpiredSessionModal.tsx — Co Marca — Sesión Expirada
import React from 'react';
import { createPortal } from 'react-dom';
import { LogOut, Clock } from 'lucide-react';

interface ExpiredSessionModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const colors = {
    primary:        '#c1348b',
    primaryDark:    '#8f1f64',
    secondary:      '#61257b',
    secondaryLight: '#8b3fa8',
    accentDark:     '#ea8406',
};

const css = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800;900&display=swap');
.esm-modal *{font-family:'DM Sans',sans-serif;box-sizing:border-box;}
@keyframes esmFadeIn{from{opacity:0;}to{opacity:1;}}
@keyframes esmSlideUp{from{opacity:0;transform:translateY(20px) scale(.97);}to{opacity:1;transform:translateY(0) scale(1);}}
@keyframes esmPulse{0%,100%{box-shadow:0 0 0 0 rgba(193, 52, 139,.35);}50%{box-shadow:0 0 0 8px rgba(193, 52, 139,0);}}
.esm-overlay{animation:esmFadeIn .2s ease both;}
.esm-dialog{animation:esmSlideUp .3s cubic-bezier(.16,1,.3,1) both;}
.esm-icon-pulse{animation:esmPulse 2s infinite;}
.esm-btn{display:inline-flex;align-items:center;gap:8px;background:linear-gradient(135deg,${colors.primary},${colors.primaryDark});color:#fff;border:none;border-radius:12px;padding:12px 28px;font-size:.92rem;font-weight:800;cursor:pointer;box-shadow:0 4px 16px rgba(193, 52, 139,.32);transition:all .22s cubic-bezier(.16,1,.3,1);font-family:'DM Sans',sans-serif;}
.esm-btn:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(193, 52, 139,.38);}
`;

const ExpiredSessionModal: React.FC<ExpiredSessionModalProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return createPortal(
        <>
            <style>{css}</style>
            <div className="esm-modal" style={{ position:'fixed', inset:0, zIndex:99999, display:'flex', alignItems:'center', justifyContent:'center', padding:'16px' }}>
                <div className="esm-overlay" style={{ position:'absolute', inset:0, background:'rgba(15,23,42,.65)', backdropFilter:'blur(8px)' }}/>

                <div className="esm-dialog" style={{ position:'relative', background:'#fff', borderRadius:'28px', width:'100%', maxWidth:'400px', boxShadow:'0 32px 80px rgba(0,0,0,.22)', border:'1.5px solid #f1f5f9', overflow:'hidden', textAlign:'center' }}>

                    {/* Barra top */}
                    <div style={{ height:'4px', background:`linear-gradient(90deg,${colors.primary},${colors.primaryDark},${colors.primary}80)` }}/>

                    <div style={{ padding:'36px 32px 32px' }}>
                        {/* Icono pulsante */}
                        <div style={{ width:'64px', height:'64px', borderRadius:'20px', background:`${colors.primary}12`, border:`1.5px solid ${colors.primary}22`, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px' }} className="esm-icon-pulse">
                            <Clock size={28} color={colors.primary}/>
                        </div>

                        <h2 style={{ fontSize:'1.3rem', fontWeight:'900', color:'#0f172a', letterSpacing:'-.02em', marginBottom:'10px' }}>
                            Sesión Expirada
                        </h2>

                        {/* Barra de colores */}
                        <div style={{ display:'flex', gap:'4px', justifyContent:'center', marginBottom:'16px' }}>
                            {[colors.primary,colors.secondary,colors.accentDark,colors.secondaryLight].map((c,i)=>(
                                <div key={i} style={{ height:'2px', width:i===0?'20px':'7px', borderRadius:'2px', background:c, opacity:.5 }}/>
                            ))}
                        </div>

                        <p style={{ fontSize:'.92rem', color:'#64748b', lineHeight:1.7, marginBottom:'28px' }}>
                            Tu sesión ha caducado por inactividad.<br/>
                            <span style={{ fontWeight:'700', color:'#374151' }}>Inicia sesión nuevamente</span> para continuar.
                        </p>

                        <button onClick={onClose} className="esm-btn">
                            <LogOut size={16}/> Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

export default ExpiredSessionModal;